var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoAvancar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.801,
    height: 20.281,
    viewBox: "0 0 20.801 20.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.347,16.169c1.117-3.595,4.663-6.048,8.914-6.121v-4.2a.374.374,0,0,1,.364-.364.392.392,0,0,1,.219.073l10.809,7.821a.355.355,0,0,1,.073.51l-.073.073L9.844,21.731a.377.377,0,0,1-.51-.073.392.392,0,0,1-.073-.219V17.262c-2.623,0-4.833,1.239-5.611,3.109-.656,1.6-.121,3.328,1.433,4.761a.353.353,0,0,1,.024.51.39.39,0,0,1-.267.121H4.549a.276.276,0,0,1-.194-.073C.784,23.334-.746,19.667.347,16.169Z",
    transform: "translate(0 -5.482)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAvancar);
export default __webpack_public_path__ + "static/media/ico-avancar.17e3b5f23fb894f14f9c13ed06d96e97.svg";
export { ForwardRef as ReactComponent };